import PageLayout from "../components/pageLayout";
import DepartmentPage from "../components/DepartmentPage";

function DepartmentDetailPage() {
  return <PageLayout children={<DepartmentPage />} />;
}

export default DepartmentDetailPage;
